import { render, staticRenderFns } from "./StudentFinanceOptions.vue?vue&type=template&id=f35ad2f4&scoped=true"
import script from "./StudentFinanceOptions.vue?vue&type=script&lang=js"
export * from "./StudentFinanceOptions.vue?vue&type=script&lang=js"
import style0 from "./StudentFinanceOptions.vue?vue&type=style&index=0&id=f35ad2f4&prod&module=true&scoped=true&lang=css"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "f35ad2f4",
  null
  
)

export default component.exports